<template>
  <div class="bg-theme pointer mb-4" style="border-radius: 8px" id="AlertCard" @click="goToCheckout">
    <div class="banner-box">
      <div class="banner-info">
        <h5 style="margin-bottom: 3px">Publique seu site</h5>
        <p style="font-size: 14px">no seu endereço www profissional</p>
        <div class="banner-active">
          <span style="font-weight: bolder">Ative agora</span>
        </div>
      </div>
      <div class="d-flex align-items-end">
        <img class="img-fluid" style="max-width: 175px;" src="../../assets/img/Uli-Foguete-Banner.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlertCard",
  methods: {
    goToCheckout() {
      var token = this.$store.state.siteActive.contract.token;
      if (token) {
        this.$router.push(`/checkout?token=${token}`);
      }
    },
  },
};
</script>

<style scoped>
.banner-box{
  justify-content: center;
  display: flex;
  color:white
}
.banner-info{
  padding-left: 32px;
  padding-top: 15px;
  padding-bottom: 15px;
  text-align: left;
}
.banner-active{
  font-size: 14px;
  font-weight: bolder;
  color: var(--bg-color);
  background-color: white;
  text-align: center;
  padding: 12px 26px 12px 26px;
  border-radius: 50vh;
  
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/AlertCard.vue